<template>
  <van-popup v-model="show" position="bottom" :style="{ 
      height: '100%'
    }">
    <van-nav-bar
      :title="`${commentInfo.Children.length}条回复`"
      left-arrow
    >
      <template slot="left">
        <span class="iconfont icon-quxiao" @click="handleClose"></span>
      </template>
    </van-nav-bar>
    <div class="w">
      <CommentBlock v-if="commentInfo" :articleAuthorId="articleAuthorId" :info="commentInfo" noSubitem notShowReplay/>
    </div>
    <div class="title w">全部评论</div>
    <div class="w">
      <CommentBlock
        v-for="cItem in commentInfo.Children"
        :key="cItem.Id"
        :info="cItem"
        :articleAuthorId="articleAuthorId"
        notShowReplay
      />
    </div>
  </van-popup>
</template>
<script>
import CommentBlock from "@/components/comment/commentBlock.vue";
import {Comment} from '@/api'

export default {
  name: "commentListPopup",
  components: {
    CommentBlock
  },
  props: {
    info: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      show: false,
      commentInfo: {
        Children: []
      },
      UserId: 0,
      currCommentInfo: {
        SourceId: 0,
        AuthorId: 0,
        isFav: false,
        name: ""
      },
      articleAuthorId: 0,
      commentCount: 0,
      showCommentBox: false
    };
  },
  created() {
    this.UserId = this.$mdUtils.getUserInfo("Id");
  },
  methods: {
    init(data) {
      this.commentInfo = data.commentInfo;
      let _currCommentInfo = data.currCommentInfo
      _currCommentInfo.name = this.commentInfo.UserName
      _currCommentInfo.ParentId = this.commentInfo.Id
      this.currCommentInfo = _currCommentInfo;
      this.commentCount = data.commentCount;
      this.articleAuthorId = data.authorId
      this.show = true;
    },
    handleSendComment() {
      this.$api(Comment.QueryVCommentByPage, {
        AppId: 1,
        Module: Comment.ModuleKey,
        SourceId: this.ArticleId,
        // UserId: this.$mdUtils.getUserInfo("Id"),
        ParentId: this.commentInfo.Id,
        IsComment: true,
        PageIndex: 1,
        PageSize: 1000
      }).then((res) => {
        this.commentInfo.Children = res.List
        let info = {
          parentId: this.commentInfo.Id,
          list: res.List
        }
        this.$emit('onSendSuccess', info)
      })
    },
    handleClose() {
      this.show = false
    }
  }
};
</script>
<style lang='scss' scoped>
</style>